import { Currency, CurrencyApi } from "../graphql/types";

export function parseCurrency(name: string): Currency {
  const upper = name.toUpperCase();
  if (Currency[upper as keyof typeof Currency]) {
    return upper as Currency;
  }
  throw new Error(`Invalid currency: ${name}`);
}

/** Defines the conversion rates for a single base currency. */
export type CurrencyRates = CurrencyApi;

export type MonetaryValue = [amount: number, currency: Currency];

/** Converts the given monetary value into the currency of targetRates.baseCurrency */
export function convertMonetaryValue(
  amount: MonetaryValue[0],
  currency: MonetaryValue[1],
  targetRates: CurrencyRates,
): number;
export function convertMonetaryValue(
  amount: MonetaryValue[0],
  currency: MonetaryValue[1],
  targetRates: null,
): null;
export function convertMonetaryValue(
  amount: MonetaryValue[0],
  currency: MonetaryValue[1],
  targetRates: CurrencyRates | null,
): number | null;
export function convertMonetaryValue(
  amount: MonetaryValue[0],
  currency: MonetaryValue[1],
  targetRates: CurrencyRates | null,
): number | null {
  if (!targetRates) {
    console.warn('convertMonetaryValue called with no currency rates');
    return null;
  }
  const rate =
    currency === targetRates.baseCurrency
      ? 1
      : targetRates?.rates?.find((r) => r?.code === currency)?.value;
  if (!rate) {
    console.error(
      `Currency rate not available: ${currency}->${targetRates.baseCurrency}`,
    );
    return amount;
  }
  return amount / Number(rate);
}

